import React, { useEffect, useState } from 'react';
import { Panel } from 'primereact/panel';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { travelService } from '../../services/extensions';


const TravelDataTable = () => {
    const [travelData, setTravelData] = useState([]);
    const [countryOptions, setCountryOptions] = useState([]);
    const [customerOptions, setCustomerOptions] = useState([]);

    useEffect(() => {
        fetchTravelData();
        fetchCountryData();
        fetchCustomerData();
    }, []);

    const fetchTravelData = () => {
        travelService.getAllTravelByUser()
            .then(response => {
                if (response.data.success) {
                    setTravelData(response.data.data);
                }
            })
            .catch(error => {
                console.error('Error fetching travel data:', error);
            });
    };

    const fetchCountryData = () => {
        travelService.GetAllCountry()
            .then(response => {
                if (response.data.success) {
                    const options = response.data.data.map(country => ({
                        label: country.countryName,
                        value: country.id
                    }));
                    setCountryOptions(options);
                }
            })
            .catch(error => {
                console.error('Error fetching countries:', error);
            });
    };

    const fetchCustomerData = () => {
        travelService.GetAllCustomer()
            .then(response => {
                if (response.data.success) {
                    const options = response.data.data.map(customer => ({
                        label: customer.title,
                        value: customer.id
                    }));
                    setCustomerOptions(options);
                }
            })
            .catch(error => {
                console.error('Error fetching customers:', error);
            });
    };

    const countryTemplate = (rowData) => {
        const country = countryOptions.find(option => option.value === parseInt(rowData.countryofVisit));
        return country ? country.label : 'N/A';
    };

    const customerTemplate = (rowData) => {
        const customer = customerOptions.find(option => option.value === parseInt(rowData.clientId));
        return customer ? customer.label : 'N/A';
    };
    const passportTemplate = (rowData) => {
        return rowData.travelDetails && rowData.travelDetails.length > 0 ? rowData.travelDetails[0].passportNumber : 'N/A';
    };
   
    return (
        <div className="tabview-demo">
            <Panel>
                <DataTable
                    value={travelData}
                    paginator
                    responsiveLayout="scroll"
                    paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                    currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                    rows={10}
                    rowsPerPageOptions={[10, 20, 50]}
                    // selectionMode="checkbox"
                    resizableColumns
                    columnResizeMode="fit"
                    scrollable="horizontal"
                    stripedRows
                    editMode="row"
                    dataKey="id"
                >
                    {/* <Column selectionMode="multiple" headerStyle={{ width: "4rem" }} exportable={false}></Column> */}
                    <Column field="id" header="Trip Id" style={{ minWidth: '10rem' }} />
                    <Column field="visaTypeInfo.title" header="Visa Type" style={{ minWidth: '10rem' }} />
                    <Column field="empEcn" header="User ECN" style={{ minWidth: '10rem' }} />
                    <Column field="givenName" header="Full Name" style={{ minWidth: '10rem' }} />
                    <Column body={customerTemplate} header="Client Name" style={{ minWidth: '10rem' }} />
                    <Column field="journeyDate" header="Journey Date" style={{ minWidth: '10rem' }} />
                    <Column body={countryTemplate} header="Country" style={{ minWidth: '10rem' }} />
                    <Column field="daentitleAmmount" header="Entitle Amount" style={{ minWidth: '10rem' }} />
                    <Column field={passportTemplate} header="Passport Number" style={{ minWidth: '10rem' }} />
                    {/* <Column body={actionsTemplate} header="Actions" style={{ minWidth: '10rem' }} /> */}
                </DataTable>
            </Panel>
        </div>
    );
}

export default TravelDataTable;
